type I18nManifest = Record<string, string>;

class I18nAssetManager {
  private manifest: I18nManifest = {};
  private manifestLoaded = false;

  private async loadManifest(): Promise<void> {
    if (this.manifestLoaded) {
      return;
    }

    // The manifest is a build artifact (vite-plugin-i18n-assets) that doesn't
    // exist in vitest runs. Node's fetch also can't parse the relative URL
    // below. Skip the fetch in tests and let getLoadPath fall back to the
    // static /locales/{lng}/{ns}.json path.
    if (import.meta.env.MODE === "test") {
      this.manifestLoaded = true;
      return;
    }

    try {
      // Use window.location.origin if in browser environment to ensure correct path
      const baseUrl = import.meta.env.BASE_URL || "/";
      const manifestUrl = baseUrl.endsWith("/")
        ? `${baseUrl}i18n-manifest.json`
        : `${baseUrl}/i18n-manifest.json`;
      const response = await fetch(manifestUrl);
      if (response.ok) {
        this.manifest = await response.json();
      } else {
        console.warn(
          `Failed to load i18n manifest from ${manifestUrl}, status: ${response.status}`
        );
      }
    } catch (error) {
      console.warn("Failed to load i18n manifest:", error);
    }
    this.manifestLoaded = true;
  }

  async getLoadPath(): Promise<
    string | ((lngs: string[], namespaces: string[]) => string)
  > {
    await this.loadManifest();

    return (lngs: string[], namespaces: string[]) => {
      const lng = lngs[0];
      const ns = namespaces[0];
      const key = `locales/${lng}/${ns}.json`;
      return this.manifest[key] || `/locales/${lng}/${ns}.json`;
    };
  }
}

export const i18nAssetManager = new I18nAssetManager();
